import React from 'react'
import PropTypes from 'prop-types'
import './CloseModalButton.scss'

const CloseModalButton = props => {
  return (<div className='close-modal-button' onClick={props.onClose}>×</div>)
}

CloseModalButton.propTypes + {
  onClose: PropTypes.func.isRequired
}

export default CloseModalButton



// WEBPACK FOOTER //
// ./src/components/CloseModalButton/CloseModalButton.js